import styled from 'styled-components'

export const MapSection = styled.div`
  width: 100%;
  height: 840px;
  display: flex;
  justify-content: center;
  margin-bottom: -54px;
  position: relative;
  .gm-style-pbc {
    z-index: 4 !important;
    font-family: StolzlMedium, serif !important;
  }
  .gm-bundled-control {
    top: 50%;
  }
  .gm-fullscreen-control {
    top: 33% !important;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 1440px) {
    height: 700px;
  }
  @media (max-width: 768px) {
    height: 510px;
    margin-bottom: -40px;
  }
  @media (max-width: 400px) {
    height: 310px;
  }
`

export const MapBackground = styled.img`
    position: absolute;
    width: 100%;
    z-index: 1;    
    top: ${props => `-${Math.floor(props.width / 7.35)}px`};
    @media (max-width: 1380px) {
      top: ${props => `-${Math.floor(props.width / 10)}px`};
    }
    @media (max-width: 1000px) {
      top: ${props => `-${Math.floor(props.width / 20)}px`};
    }
    @media (max-width: 500px) {
      top: ${props => `-${Math.floor(props.width / 30)}px`};
    }
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  .descriptionSection {
    display: flex;
    width: 100%;
    justify-content: space-between;
    @media (max-width: 1000px) {
      display: flex;
      flex-wrap: wrap;
    }
    .descriptionDiv {
      @media (max-width: 1450px) {
        max-width: 547px;
      }
      @media (max-width: 1000px) {
        max-width: 768px;
      }
    }
  }
  .descriptionLink {
    max-width: 86vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .widget {
    margin-top: 135px;
    @media (max-width: 1000px) {
      position: unset;
      width: 100vw;
      border-radius: 0;
      margin-top: 30px;
    }
    @media (max-width: 600px) {
      margin-top: 11px;
      margin-bottom: 35px;
    }
    .header {
      @media (max-width: 600px) {
        margin-left: -10px;
      }
    }
    .innerDiv {
      @media (max-width: 1220px) {
        padding-left: 50px;
      }
      @media (max-width: 1100px) {
        padding-left: 40px;
      }
      @media (max-width: 768px) {
        padding: 55px 0 0 0;
        margin-left: 50px;
      }
      @media (max-width: 600px) {
        margin-left: 30px;
      }
    }
  }
`

export const ExpertsList = styled.div`
  z-index: 2;
  display: flex;  
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
  @media (max-width: 768px) {
    margin-top: 48px;
  }
  .expertsSocials {
    margin-top: 15px;
  }
  h3 {
    font-family: StolzlMedium, serif;
    font-weight: 500;
    text-transform: uppercase;
    @media (max-width: 1000px) {
      text-align: center;
    }
    @media (max-width: 600px) {
      margin-left: 20px;
      text-align: left;
    }
  }
  .list {
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 1000px) {
      justify-content: center;
    }
  }
  img {
    width: 100px;
    height: 100px;
    background-color: aqua;
    border-radius: 100px;
    margin-bottom: 12px;
    object-fit: cover;
  }
  .firstName {
    @media (max-width: 600px) {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.57;
      letter-spacing: normal;
    }
  }
  .lastName {
    @media (max-width: 600px) {
      font-weight: 300;
      line-height: 1.57;
      letter-spacing: normal;
    }
  }
  .expertDiv {
    :not(:last-child) {
      margin-right: 65px;
      @media (max-width: 600px) {
        margin-right: 50px;
      }
    }
    display: flex;  
    flex-direction: column;
    align-items: center;
  }
`

export const PerformanceEntry = styled.div`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 2px;
  font-size: 20px;
  margin-bottom: 29px;
  max-height: 118px;
  .timeEntry {
    display: flex;
  }
  .star {
    :hover {
      fill: #933EC5;
    }
    fill: #fff;
    transition: fill .4s ease;
    width: 30px;
    height: 30px;
    margin-right: 19px;
    @media (max-width: 600px) {
      width: 25px;
      height: 25px;
    }
  }
  :last-child { 
   margin-bottom: 70px;
  }
  @media (max-width: 768px) {
    :nth-child(2) {
      margin-top: 0;
    }
    :nth-of-type(3) {
      margin-bottom: 70px;
    }
  }
  button {
    background: none;
    border: none;
    outline: none;
    padding: 0;
    cursor: pointer;
  }
  .timeHeader {
    font-family: StolzlMedium, serif;
    font-weight: 500;  
    width: 94px;
    @media (max-width: 1220px) {
      width: 78px;
    }
  }
  
  .placeLink {
    text-decoration: none;
    max-width: 420px;
    //white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-weight: 300;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    margin-left: 49px;
    @media (max-width: 1000px) {
      max-width: 60vw;
    }
    @media (max-width: 768px) {
      line-height: 1.88;
    }
    :hover {
      color: #933EC5;
    }
  }
`

export const PlaceRegisterLink = styled.a`
  position: absolute;
  top: 0;
  left: calc(100vw - 590px);
  background-color: white;
  padding: 24px 40px 24px 30px;
  border-radius: 37px;
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
  font-size: 20px;
  font-family: StolzlMedium, serif;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  color: #000000;
  text-decoration: none;
  text-transform: uppercase;
  display: flex;
  align-items: flex-end;
  transition-duration: 0.3s;
  transform-origin: left;
  
  &:hover {
    color: #933ec5;
  }
  
  svg, img {
    padding-right: 25px;
  }
  
  @media (max-width: 1300px) {
    right: 125px;
    left: auto;
  }
  
  @media (max-width: 1000px) {
    position: static;
    margin-left: 60px;
    padding: 12px 20px 12px 15px;
    font-size: 16px;
    
    svg, img {
      width: 30px;
      height:  30px;
      padding-right: 15px;
    }
    
  }
  
  @media (max-width: 768px) {
      margin: 0 auto;
      margin-top: 15px;
  }
`
